import { Entity } from '@backstage/catalog-model';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import useAsync from 'react-use/lib/useAsync';

import { getRelationWarnings } from './helpers';

export const WarningRelationshipsColumn = ({ entity }: { entity: Entity }) => {
  const catalogApi = useApi(catalogApiRef);
  const { loading, error, value } = useAsync(
    async () => getRelationWarnings(entity, catalogApi),
    [entity, catalogApi],
  );

  if (error || loading || !value?.length) {
    return <></>;
  }
  return <>{value.length}</>;
};
